export type MasterFilterState = 'active' | 'inactive' | 'all';

export type MasterSectionStats = {
  all: number;
  active: number;
  inactive: number;
};

export function mastersFilterOptions(labels: { active: string; inactive: string; all: string }) {
  return [
    { id: 'active' as const, label: labels.active },
    { id: 'all' as const, label: labels.all },
    { id: 'inactive' as const, label: labels.inactive },
  ];
}

export const MASTERS_WIDE_LAYOUT_BREAKPOINT = 768;
